import script from "./GradientBg.vue?vue&type=script&setup=true&lang=js"
export * from "./GradientBg.vue?vue&type=script&setup=true&lang=js"

import "./GradientBg.vue?vue&type=style&index=0&id=23d30520&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d30520"]])

export default __exports__